export type Mode = (typeof transitModes)[number];

export const transitModes = [
  "animal",
  "bike",
  "bus",
  "cablecar",
  "car",
  "ferry",
  "helicopter",
  "nightbus",
  "nighttrain",
  "plane",
  "rideshare",
  "shuttle",
  "subway",
  "taxi",
  "train",
  "tram",
  "towncar",
  "unknown",
  "walk",
  "busferry",
  "carferry",
  "multi",
] as const;
